import iconAttorneys from "../assets/icons/generic/IconLawyers";
import costsSecureIcon from "../assets/icons/generic/IconCostSecurity";
import iconAttorneyCheck from "../assets/icons/settlement/iconAttorneyCheck";
import iconCalculateSettlement from "../assets/icons/settlement/IconMoney";
import iconInformation from "../assets/icons/generic/IconGuidebook";
import iconDocument from "../assets/icons/generic/IconDocument";
import familyLawTeaser from "../assets/img/products/Illustration_Familienrecht.webp";
import employmentLawTeaser from "../assets/img/products/Illustration_Arbeitsrecht.webp";
import civilLawTeaser from "../assets/img/products/Illustration_AllgemeinesZivilrecht.webp";
import trafficTeaser from "../assets/img/products/Illustration_Verkehrsrecht.webp";
import contractLawTeaser from "../assets/img/products/Illustration_Vertragsrecht.webp";
import tenancyLawTeaser from "../assets/img/products/Illustration_Mietrecht.webp";
import AnwaelteWbs from "../assets/icons/landingpage/wbs/IconLawyersWbs";
import IconCostSecurityWbs from "../assets/icons/landingpage/wbs/IconCostSecurityWbs";

export const legalFieldPageConfig = {
  administrativeLaw: {
    pageTitle: "Verwaltungsrecht verständlich erklärt – Ihre Rechte im Überblick | Legalbird",
    headline: "Verwaltungsrecht",
    subtitle: "",
    headlineImage: "",
    topicList: [],
  },
  civilLaw: {
    pageTitle: "Allgemeines Zivilrecht verständlich erklärt – Ihre Rechte im Überblick | Legalbird",
    headline: "Allgemeines Zivilrecht",
    subtitle: "Verleumdung, Unterlassung oder Schadenersatz – wir helfen Ihnen, Ihre Rechte im Alltag effektiv durchzusetzen!\n",
    headlineImage: civilLawTeaser,
    topicList: [
      {
        headline: "Schadensersatz",
        subText: "Bei einem materiellen oder finanziellen Schaden machen wir Ihre Rechte direkt gegenüber dem Verursacher geltend.",
      },
      {
        headline: "Tierhalterhaftung",
        subText: "Nach einer Tierattacke oder einem Hundebiss nehmen wir den Halter oder dessen Versicherung für Sie in die Pflicht.",
      },
      {
        headline: "Schmerzensgeld",
        subText: "Nach einem Unfall oder einer Verletzung prüfen wir Ihren Anspruch und fordern ein angemessenes Schmerzensgeld für Sie.",
      },
      {
        headline: "Nachbarschaft",
        subText: "Bei Streit über Lärm, Hecken oder Grundstücksgrenzen vertreten wir Ihre Interessen sowohl außergerichtlich als auch vor Gericht.",
      },
    ],
  },
  familyLaw: {
    pageTitle: "Familienrecht verständlich erklärt – Ihre Rechte im Überblick | Legalbird",
    headline: "Familienrecht",
    subtitle:
      "Scheidung, Unterhalt und alle anderen Themen im Familienrecht - wir begleiten Sie persönlich und finden auch in emotionalen Situationen klare Lösungen!",
    headlineImage: familyLawTeaser,
    topicList: [
      {
        headline: "Scheidung",
        subText: "Wir begleiten Sie professionell und persönlich bei allen rechtlichen Schritten einer Scheidung.",
      },
      {
        headline: "Unterhalt",
        subText: "Wir unterstützen Sie bei der Berechnung des Unterhalts sowie bei allen Fragen und Unstimmigkeiten zu diesem Thema.",
      },
      {
        headline: "Todesfall & Erbrecht",
        subText: "Beratung und rechtlicher Beistand bei allen Angelegenheiten rund um Erbrecht und Todesfälle.",
      },
      {
        headline: "Allgemeines Familienrecht",
        subText: "Wir unterstützen Sie bei allen weiteren familiären Rechtsfragen und allgemeinen Anliegen.",
      },
    ],
  },
  trafficLaw: {
    pageTitle: "Verkehrsrecht verständlich erklärt – Ihre Rechte im Überblick | Legalbird",
    headline: "Verkehrsrecht",
    subtitle: "Zu schnell gefahren, rote Ampel übersehen oder in einen Verkehrsunfall verwickelt worden? Wir kümmern uns für Sie darum!",
    headlineImage: trafficTeaser,
    topicList: [
      {
        headline: "Verkehrsunfall",
        subText:
          "Wir setzen Ihre Ansprüche gegenüber dem Unfallgegner und dessen Kfz-Haftpflichtversicherer durch und sorgen für eine faire und zügige Entschädigung.",
      },
      {
        headline: "Tempoverstoß",
        subText: "Bußgeld und Punkte wegen Geschwindigkeitsverstoß vermeiden oder reduzieren.",
      },
      {
        headline: "Rotlichtverstoß",
        subText: "Professionell gegen Bußgeld oder Fahrverbot wegen überfahrenen Rotlichts vorgehen.",
      },
      {
        headline: "Abstandsverstoß",
        subText: "Zu nah aufgefahren? Wir prüfen das vermeintliche Vergehen und setzen uns für Sie ein.",
      },
      {
        headline: "Handy/ Drogen/ Parken/ Sonstiges",
        subText: "Hilfestellung bei allen sonstigen Arten von Bußgeldern im Bereich Verkehr.",
      },
    ],
  },
  employmentLaw: {
    pageTitle: "Arbeitsrecht verständlich erklärt – Ihre Rechte im Job | Legalbird",
    headline: "Arbeitsrecht",
    subtitle: "Ärger mit Ihrem Arbeitgeber oder der Behörde, für die Sie arbeiten? Wir unterstützen Sie bei allen Themen rund um Ihr Arbeitsverhältnis.",
    headlineImage: employmentLawTeaser,
    topicList: [
      {
        headline: "Allgemeines Arbeitsrecht",
        subText: "Probleme am Arbeitsplatz? Professionelle Begleitung bei allen Fragen im allgemeinen Arbeitsrecht.",
      },
      {
        headline: "Abfindung bei Kündigung",
        subText: "Ihnen wurde gekündigt? Wir gehen dagegen vor und prüfen Ihre Möglichkeiten auf eine Abfindung.",
      },
      {
        headline: "Beamtenrecht",
        subText: "Zuverlässige rechtliche Beratung für alle spezifischen Anliegen im Beamtenrecht.",
      },
      {
        headline: "Rückkehr an den Arbeitsplatz",
        subText: "Wir setzen uns für Ihr Recht auf Weiterbeschäftigung und die Rückkehr an Ihren Arbeitsplatz ein.",
      },
    ],
  },
  contractLaw: {
    pageTitle: "Vertragsrecht verständlich erklärt – Ihre Rechte rund um Verträge | Legalbird",
    headline: "Vertragsrecht",
    subtitle: "Probleme mit dem Stromanbieter, beim Autokauf, mit Fake-Shops oder anderen Verträgen - Wir setzen Ihre Ansprüche durch!",
    headlineImage: contractLawTeaser,
    topicList: [
      {
        headline: "Kaufvertrag",
        subText: "Unterstützung bei Problemen mit Ihrem Kaufvertrag - egal ob als Käufer oder Verkäufer.",
      },
      {
        headline: "Fahrzeugkauf",
        subText: "Hilfe bei allen Vertragsthemen rund um den Kauf oder Verkauf von Fahrzeugen.",
      },
      {
        headline: "Handwerker / Dienstleistung",
        subText: "Wir setzen uns für Sie ein, wenn zum Beispiel Ihr Handwerker die Leistung nicht wie vereinbart erfüllt.",
      },
      {
        headline: "Mitgliedschaft",
        subText: "Uneinigkeiten mit Ihren Mitgliedschaften, beispielsweise Ihrem Fitnessstudio oder Sportverein.",
      },
      {
        headline: "Abo / Abofalle",
        subText: "Sie sind in eine Abofalle geraten? Wir wehren die Forderung für Sie ab.",
      },
      {
        headline: "Handy / DSL / Strom / Gas-Vertrag",
        subText: "Für alle Probleme mit Versorgern, wie Mobilfunkanbietern oder Stromversorger.",
      },
      {
        headline: "Reisevertrag",
        subText: "Reisen sollten entspannend sein, daher helfen wir bei allen Problemen rund um dem Reisevertrag.",
      },
      {
        headline: "Veranstaltung",
        subText: "Veranstaltung ausgefallen, verschoben oder sonstige Probleme? Wir unterstützen Sie!",
      },
      {
        headline: "Sonstiger Vertrag",
        subText: "Auch bei allen anderen Verträgen helfen wir Ihnen weiter! Eine kurze Schilderung genügt!",
      },
    ],
  },
  tenancyLaw: {
    headline: "Mietrecht",
    pageTitle: "Mietrecht verständlich erklärt – Ihre Rechte als Mieter | Legalbird",
    subtitle: "Ob als Mieter oder Vermieter – wir unterstützen Sie bei allen Fragen rund um Ihren Mietvertrag und setzen Ihre Rechte konsequent durch!",
    headlineImage: tenancyLawTeaser,
    topicList: [
      {
        headline: "Mietmängel",
        subText: "Heizung ausgefallen oder Schimmel im Schlafzimmer? Wir sorgen dafür, dass Mietmängel zeitnah behoben werden.",
      },
      {
        headline: "Mietminderung",
        subText: "Lärmbelästigung oder andere Mängel, die nicht behoben werden, dann helfen wir Ihnen dabei, die Miete zu mindern.",
      },
      {
        headline: "Mieterhöhung",
        subText: "Ihre Miete wurde unrechtmäßig erhöht und Sie möchten dagegen vorgehen.",
      },
      {
        headline: "Nebenkostenabrechnung",
        subText: "Sie haben eine sehr hohe Abrechnung erhalten, die Ihnen falsch erscheint? Wir prüfen Ihre Nebenkostenabrech-nung auf Rechtmäßigkeit.",
      },
      {
        headline: "Kaution",
        subText: "Wenn die Kaution Ihnen gar nicht oder nicht vollständig zurückgezahlt wird, setzen wir uns für Sie ein.",
      },
      {
        headline: "Kündigung",
        subText: "Ihnen wurde das Mietverhältnis gekündigt und Sie möchten wissen, ob dies rechtmäßig war? Dann prüfen wir dies gerne für Sie.",
      },
      {
        headline: "Mietvertrag prüfen",
        subText: "Sie möchten einen neuen Mietvertrag unterzeichnen oder sind allgemein unsicher, ob Ihr Vertrag rechtmäßig ist.",
      },
    ],
  },
};

export const defaultProvenExpertTeaserCard = {
  icon: "https://images.provenexpert.com/ca/70/17a7e460654ab3270025208dddab/widget_square_200_de_0.png",
  heading: "Persönlich & schnell",
  link: "https://www.provenexpert.com/legalbird/?utm_source=Widget&amp;utm_medium=Widget&amp;utm_campaign=Widget",
  linkType: "external",
  hideMobileButton: true,
};

export const getProvenExpertTeaserCardWithHeading = (heading: string) => {
  let provenExpertTeaserCard = { ...defaultProvenExpertTeaserCard };
  provenExpertTeaserCard.heading = heading;
  return provenExpertTeaserCard;
};

export const divorceTeaserCards = [
  defaultProvenExpertTeaserCard,
  {
    icon: iconAttorneys,
    heading: "Professionelle Beratung",
  },
  {
    icon: costsSecureIcon,
    heading: "Kostenlose Prüfung",
  },
];

export const wbsTeaserCards = [
  {
    icon: IconCostSecurityWbs,
    heading: "Kostenlose Prüfung",
  },
  {
    icon: AnwaelteWbs,
    heading: "Professionelle Beratung",
  },
  defaultProvenExpertTeaserCard,
];

export const settlementChoiceCards = [
  {
    icon: iconAttorneyCheck,
    heading: "Kostenlos prüfen",
  },
  {
    icon: iconCalculateSettlement,
    heading: "Abfindung berechnen",
  },
  {
    icon: iconInformation,
    heading: "Allgemein informieren",
  },
];

export const settlementTeaserCards = [
  defaultProvenExpertTeaserCard,
  {
    icon: iconAttorneys,
    heading: "Professionelle Beratung",
  },
  {
    icon: costsSecureIcon,
    heading: "Kostenlose Prüfung",
  },
];

export const contractTeaserCards = [
  defaultProvenExpertTeaserCard,
  {
    icon: iconAttorneys,
    heading: "Professionelle Beratung",
  },
  {
    icon: iconDocument,
    heading: "Unkomplizierte Abwicklung",
  },
];

export const alimonyTeaserCards = [
  getProvenExpertTeaserCardWithHeading("Schnell & effektiv"),
  {
    icon: iconAttorneys,
    heading: "Professionelle Beratung",
  },
  {
    icon: costsSecureIcon,
    heading: "Unterhalt berechnen",
  },
];

export const documentTeaserCards = [
  getProvenExpertTeaserCardWithHeading("Schnell & effektiv"),
  {
    icon: iconAttorneys,
    heading: "Professionelle Beratung",
  },
  {
    icon: iconDocument,
    heading: "Persönliches Dokument",
  },
];

export const trafficTeaserCards = [
  getProvenExpertTeaserCardWithHeading("Schnell & effektiv"),
  {
    icon: iconAttorneys,
    heading: "Professionelle Beratung",
  },
  {
    icon: costsSecureIcon,
    heading: "Kostenlose Ersteinschätzung",
  },
];
